import { render, staticRenderFns } from "./Consents.vue?vue&type=template&id=be4e0e62&scoped=true&"
import script from "./Consents.vue?vue&type=script&lang=js&"
export * from "./Consents.vue?vue&type=script&lang=js&"
import style0 from "./Consents.vue?vue&type=style&index=0&id=be4e0e62&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4e0e62",
  null
  
)

export default component.exports